(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `70px`);
      if (this
          .header
          .querySelector(".header-wrapper")
          .classList
          .contains("header-fixed")) {
        document.body.classList.add('show-header-fixed');
      }
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    // The raw scroll event only schedules one evaluation per animation frame. A fast fling
    // fires dozens of scroll events per frame; running the class toggles below (which
    // invalidate the transparent-header selectors) on every one of them is what made scrolling
    // the home page feel heavy.
    onScroll() {
      if (this._scrollTicking) return;
      this._scrollTicking = true;
      requestAnimationFrame(() => {
        this._scrollTicking = false;
        this.evaluateScrollPosition();
      });
    }

    evaluateScrollPosition() {
      if (!this.isConnected) return;

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      this.setHeaderClass('scrolled-disable-transparent', scrollTop > 100);

      if (scrollTop > this.currentScrollTop) {
        this.setHeaderClass('scrolled-past-header', true);
        this.setBodyScrolled(true);
        if (this.preventHide) return;

        this.hide();
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.setHeaderClass('scrolled-past-header', true);
        this.setBodyScrolled(true);
        if (!this.preventReveal) {
          this.reveal();
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          this.hide();
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.setHeaderClass('scrolled-past-header', false);
        this.setBodyScrolled(false);
        this.reset();
      }

      this.currentScrollTop = scrollTop;
    }

    // Only touch the DOM when the flag actually changes, so an unchanged scroll state doesn't
    // re-run style resolution for the header's transparency selectors.
    setHeaderClass(name, on) {
      this._headerClasses = this._headerClasses || {};
      if (this._headerClasses[name] === on) return;
      this._headerClasses[name] = on;
      this.header.classList.toggle(name, on);
    }

    setBodyScrolled(on) {
      if (this._bodyScrolled === on) return;
      this._bodyScrolled = on;
      document.body.classList.toggle('scrolled', on);
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
